import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login'
import Index from '../views/Index'
import currency from '@/components/common/currency'
import preView from '@/components/oilSituation/preView'
import grainPreView from '@/components/grain/grainPreView'
import contrastPreView from '@/components/grain/contrastPreView'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path:'/currency/:nav',
    name:'currency',
    component:currency
  },
  {
    path:'/preView',
    name:'preView',
    component:preView
  },
  {
    path:'/grainPreView',
    name:'grainPreView',
    component:grainPreView
  },{
    path:'/contrastPreView',
    name:'contrastPreView',
    component:contrastPreView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
